<template>
    <!-- Start Header -->
    <header>
      <!--Start Navbar-->
      <nav class="navbar navbar-expand-lg navbar-inner fixed-top custom-nav sticky w-100 rounded-0 mb-0" ref="navbar">
        <div class="menu-overlay"></div>
        <div class="container">
          <!-- LOGO -->
          <a class="navbar-brand brand-logo mr-4" href="#home">
            <img src="assets/images/CNS_logo_side_small.png" class="img-fluid logo-light" alt="">
            <img src="assets/images/CNS_logo_side_small_dark.png" class="img-fluid logo-dark" alt="">
          </a>
          <button class="navbar-toggler" type="button" @click="toggleNavbar" aria-controls="navbarNav" :aria-expanded="isNavbarOpen.toString()" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" :class="{ show: isNavbarOpen }" id="navbarNav">
<ul class="navbar-nav navbar-center">
              <li class="nav-item">
                <router-link to="/" class="nav-link text-white transition text-uppercase">Home</router-link>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link text-white transition text-uppercase dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Services
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><router-link to="/network-protection" class="dropdown-item">Network Protection & Firewalls</router-link></li>
                  <li><router-link to="/managed-it-services" class="dropdown-item">Managed IT Services</router-link></li>
                  <li><router-link to="/oilfield-remote-it" class="dropdown-item">Oilfield & Remote Site IT</router-link></li>
                  <li><router-link to="/camera-nvr-networks" class="dropdown-item">Camera & NVR Networks</router-link></li>
                </ul>
              </li>
              <li class="nav-item">
                <router-link to="/about" class="nav-link text-white transition text-uppercase">About</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/contact" class="nav-link text-white transition text-uppercase">Contact</router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <!-- End Navbar -->
    </header>
    <!-- End Header -->
  </template>
  
  <script>
  export default {
    name: "cynexsol_header",
    data() {
      return {
        isNavbarOpen: false, // Track the state of the navbar
      };
    },
    methods: {
      toggleNavbar() {
        this.isNavbarOpen = !this.isNavbarOpen; // Toggle navbar visibility
      },
      closeNavbar() {
        this.isNavbarOpen = false; // Close the navbar when a link is clicked
      },
      handleClickOutside(event) {
        // If click is outside the navbar, collapse the navbar
        if (this.$refs.navbar && !this.$refs.navbar.contains(event.target)) {
          this.isNavbarOpen = false;
        }
      },
    },
    mounted() {
      // Add event listener to detect click outside the navbar
      document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
      // Remove event listener when component is destroyed
      document.removeEventListener("click", this.handleClickOutside);
    },
  };
  </script>
  
  <style scoped>
  /* Add any additional custom styles for your header here */
    .navbar-brand img {
    height: 40px;
    max-height: 40px;
    width: auto;
  }

  @media only screen and (max-width: 479px) {
    .custom-nav .navbar-brand.brand-logo img {
        height: 30px;
    }
  }
  </style>
  